// domainHelper
import {
  domainMap,
  PUREFLO_SLUG,
  WATER_SLUG,
  SPARKLETTS_SLUG,
  AUTH_CLIENT_IDS,
} from 'containers/Landing/constants';
import { getServerData } from 'utils/getServerData';

const env = getServerData('ENVIRONMENT');

export const HOSTNAMES_US = [
  'sparkletts',
  'crystal-springs',
  'hinckleysprings',
  'kentwoodsprings',
  'alhambrawater',
  'deeprockwater',
  'mountolympuswater',
  'sierrasprings',
  'crystalrock',
];

export const HOSTNAMES_US_PLUS = [...HOSTNAMES_US, 'water'];

export const HOSTNAMES_CA = ['labradorsource', 'canadiansprings'];

export const HOSTNAMES_CA_PLUS = [...HOSTNAMES_CA, 'aquaterracorp'];

export const HOSTNAMES = [...HOSTNAMES_US, ...HOSTNAMES_CA];

export const HOSTNAMES_PLUS = [...HOSTNAMES_US_PLUS, HOSTNAMES_CA_PLUS];

export const US_BRANDS = [
  'Alhambra',
  'Crystal Rock',
  'Crystal Springs',
  'Deep Rock',
  'Hinckley Springs',
  'Kentwood Springs',
  'Mount Olympus',
  'Sierra Springs',
  'Sparkletts',
];

export const CA_BRANDS = ['Canadian Springs', 'Labrador Source'];

export const ALL_BRANDS = [...US_BRANDS, ...CA_BRANDS];

export const purefloCheck = (hostname) =>
  hostname && hostname.includes('pureflo');

export const getDomainByHost = () => domainMap[SPARKLETTS_SLUG];

export const getAcquisitionOrigin = (brand) => {
  if (!window) return '';

  const { hostname, protocol } = window.location;

  if (RegExp(/^[A-z-]+.localhost$/).test(hostname)) {
    return `${protocol}//${brand}.localhost`;
  }

  const host = isProduction()
    ? `www.${brand}.com`
    : `${brand}-acq-${env}.dss-aws.com`;

  return `https://${host}`;
};

export const isAcquisitionDomain = () => {
  const domain = getDomainByHost(28);
  return domain.slug && domain.slug.includes('acquisition');
};

// TODO: Add https support at SSR server layer
export const getProtocol = () =>
  getServerData('ENVIRONMENT') === 'dev' ? 'http' : 'https';

export const isPurefloDomain = () => {
  const { slug } = getDomainByHost(29);
  return slug === PUREFLO_SLUG;
};

export const isSelfServeDomain = () => {
  const { slug } = getDomainByHost(30);
  return (
    slug !== PUREFLO_SLUG &&
    !slug.startsWith('costcowater') &&
    !isAcquisitionDomain()
  );
};

export const isAcquisitionOrCostcoDomain = () => {
  const { slug } = getDomainByHost();
  return slug.includes('acquisition') || slug.startsWith('costcowater');
};

export const isWaterDomain = () => {
  const { slug } = getDomainByHost(31);

  return slug === WATER_SLUG;
};

export const getAuthClientId = () => AUTH_CLIENT_IDS[WATER_SLUG];

export const getBrandName = (brandSlug) => {
  switch (brandSlug) {
    case 'crystal-springs':
      return 'Crystal Springs';
    case 'crystalrock':
      return 'Crystal Rock';
    case 'alhambrawater':
      return 'Alhambra';
    case 'labradorsource':
      return 'Labrador Source';
    case 'canadiansprings':
      return 'Canadian Springs';
    case 'deeprockwater':
      return 'Deep Rock';
    case 'hinckleysprings':
      return 'Hinckley Springs';
    case 'kentwoodsprings':
      return 'Kentwood Springs';
    case 'mountolympuswater':
      return 'Mount Olympus';
    case 'sierrasprings':
      return 'Sierra Springs';
    case 'sparkletts':
      return 'Sparkletts';
    default:
      return 'Sparkletts';
  }
};

// FIXME much in this codebase uses getRegionalBrandName, but they
// should be refactored to use the useBrand hook or similar
export const getRegionalBrandName = () => getBrandName(SPARKLETTS_SLUG);

export const isProduction = () => env === 'production';
